<template>
  <rich-suggestion
    ref="suggestion"
    :editor="editor"
    :lookup-function="findMatches"
    plugin-name="suggestion-tag"
    matcher-char="#"
    mention-class="badge badge-success"
    mention-type="tag"
    insert-new
  >
    <template #default="{ item }">
      <span>
        <strong class="inline-block mr-2">#{{ item.value }}</strong>
        <small class="text-muted">{{ item.count }} uses</small>
      </span>
    </template>
  </rich-suggestion>
</template>

<script>
  import RichSuggestion from '@/Atoms/RichSuggestion';
  import { CaseResource } from '@/api-resources';
  import axios from 'axios';

  export default {
    name: 'RichSuggestionTag',

    components: {
      RichSuggestion,
    },

    props: {
      editor: null,
      relatedCase: CaseResource,
    },

    computed: {
      plugin() {
        return this.$refs.suggestion.plugin;
      },
    },

    data() {
      return {
        cancelSource: null,
      };
    },

    methods: {
      findMatches(query) {
        this.cancelSource && this.cancelSource.cancel();
        this.cancelSource = axios.CancelToken.source();

        return this.$api('suggestions.tags', { version: '1.0', term: query }, {}, this.cancelSource.token)
          .then((response) => {
            return response.data.data.map((tag) => ({ ...tag, label: tag.value }));
          })
          .catch(() => {});
      },
    },
  };
</script>
